module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[7]128.82ae034.woff2";